import PT_PRODUCTS from './pt-products'

const PT = {
  products: PT_PRODUCTS,

  default: {
    removeItemFromList: 'Remover item da lista',
    goBack: 'Voltar',
    btnEdit: {
      save: 'Salvar',
      edit: 'Editar'
    },
    btn: {
      consult: 'Consultar',
      detail: 'Detalhes',
    },
    labelPolicy: {
      start: 'Declaro ter lido e aceito o ',
      contract: 'Contrato de Adesão ao 4KST Consulta'
    },
    cpfSearch: 'CPF',
    cpfFieldError: 'CPF Invalido.',
    cnpjFieldError: 'CNPJ Invalido.',
    close: 'Fechar',
    cancel: 'Cancelar',
    save: 'Salvar',
    clickHere: 'Clique aqui'
  },

  appBar: {
    balance: 'Saldo:'
  },

  consultHistory: {
    title: 'Consultas realizadas nessa sessão',
    caption: 'Encontram-se abaixo as consultas de CPF que você realizou.',
    header: {
      timestamp: 'Data e Hora da Consulta',
      cpf: 'CPF',
      type: 'Tipo'
    }
  },

  modals: {
    subscription: {
      title: 'Detalhes da sua assinatura',
      planIncludes: 'Ao assinar, você terá:',
      discount: '{{discount}}% de desconto sobre o valor de cada consulta.',
      credit: '{{credit}} em seu saldo para utilizar.',
      errors: {
        loading: 'Erro ao carregar as informações! Entre em contato com o suporte.',
        subscribe: 'Erro ao assinar o plano'
      },
      month: 'mês',
      billingDay1: 'Você será cobrado todo dia',
      billingDay2: 'na forma de pagamento a ser escolhida. Ao escolher cartão, as cobranças serão automáticas.',
      btnSubscribe: 'Entendi, Ir ao Pagamento',
      success: {
        title: 'Pagamento',
        text: 'Pronto! Agora é necessário realizar o pagamento da sua assinatura. Caso você não for redirecionado automaticamente, clique no botão abaixo para ser ir à página de pagamento, no site do Asaas.com, com conexão segura.',
        btnPay: 'Ir ao Pagamento'
      },
      btnPayActive: 'Ver Cobranças'
    },
    cancelSubscription: {
      title: 'Cancelar assinatura',
      error: 'Erro ao cancelar sua assinatura! Contate nosso suporte.',
      proceed: 'Prosseguir com o cancelamento',
      sdr: 'Falar com SDR',
      confirm: 'Confirmar cancelamento',
      steps: {
        0: {
          text: 'Antes de cancelar, gostaríamos saber o motivo do seu cancelamento:',
          reasons: {
            1: 'Não preciso mais fazer análise de crédito.',
            2: 'Usei o produto para minha consulta pessoal.',
            3: 'Decidi usar outra ferramenta para análise de crédito.',
            4: 'O produto não atendeu às minhas necessidades.',
            5: 'Não consegui suporte técnico e de pós-vendas.',
            6: 'Vou trocar de plano.'
          }
        },
        1: {
          text: 'Em uma escala de 0 (ruim) a 5 (excelente), como você avalia a qualidade dos dados do 4KST Consulta?'
        },
        2: {
          text: 'Sentimos muito que nosso produto não tenha atendido suas necessidades. Caso queira receber atendimento personalizado, clique para falar com um SDR, ou confirme, para prosseguir com seu cancelamento.'
        }
      }
    },
    availableSale: {
      title: 'Há uma promoção disponível!',
      register: 'Efetue seu cadastro até {{date}} para desfrutar da promoção.',
      registerBtn: 'Continuar ao Cadastro'
    },
    block: {
      title: 'Bloquear usuário',
      error: 'Erro ao bloquear o usuário. Entre em contato com o suporte!',
      confirm: 'Bloquear'
    },
    customer: {
      register: {
        title: 'Registrar novo usuário'
      }
    },
    unblock: {
      title: 'Desbloquear usuário',
      error: 'Erro ao desbloquear o usuário. Entre em contato com o suporte!',
      confirm: 'Desbloquear'
    },
    financial: {
      title: 'Gerar cobrança',
      chooseType: 'Tipo de cobrança',
      copyToClipboard: 'Clique para copiar',
      confirm: 'Gerar cobrança',
      unknownFetchError: 'Erro desconhecido. Contate a equipe técnica!',
      radio: {
        payment: 'Avulsa',
        subscription: 'Assinatura'
      },
      config: {
        invalidValue: 'Valor inválido.',
        issTax: {
          title: 'Atualizar alíquota ISS',
          fieldLabel: 'Alíquota ISS (%)',
          update: 'Atualizar',
          unknownFetchError: 'Erro desconhecido. Contate a equipe técnica!'
        }
      }
    },
    plans: {
      name: 'Nome',
      description: 'Descrição',
      discount: 'Desconto',
      validUntil: 'Válido até',
      validUntilTooltip: 'Todos os planos têm data de expiração. Uma vez que um plano expira, ele não estará mais disponível para contratação.',
      isTrial: 'Criar como Plano Experimental?',
      isTrialTooltip: 'Plano Experimental: plano gratuito com duração de 14 dias, disponível para novos clientes ou clientes que não tenham adquirido planos experimentais anteriormente e possuam um plano experimental em sua tabela de planos.',
      isTransitionOnly: 'Disponibilizar apenas para usuários de transição?',
      isTransitionOnlyTooltip: 'Plano de Transição: atualmente, esta opção é utilizada somente em Planos Experimentais. Planos de Transição indicam que apenas clientes em transição de tabelas de planos têm direito àquele Plano Experimental, excluindo clientes novos. Essa opção é útil, por exemplo, para atribuir diferentes versões de um mesmo plano à clientes de transição e clientes novos, onde o plano de transição inclui um desconto diferente do plano para clientes novos.',
      addToPlanTables: 'Adicionar plano à tabelas de planos existentes:',
      expandEntryList: 'Adicionar tabela',
      planTable: 'Tabela de Planos',
      price: 'Preço',
      monthlyPrice: 'Mensalidade',
      createPlan: 'Criar plano',
      insertPlan: 'Inserir plano',
      create: {
        title: 'Criar Plano',
        missingName: 'Nome é obrigatório.',
        missingDiscount: 'Desconto é obrigaório.',
        missingValidUntil: 'Válido até é obrigatório.',
        invalidDiscount: 'Desconto inválido.',
        invalidDiscountInterval: 'Insira um número entre 1 e 100.',
        errorRepeatedPlanTables: 'Foram selecionadas duas ou mais tabelas de planos iguais. Por favor verifique a lista!',
        unknownError: 'Erro desconhecido. Contate o suporte!',
        unknownFetchError: 'Ocorreu um erro ao carregar os dados. Contate o suporte!',
        unknownPlanTableError: 'Ocorreu um erro ao carregar as tabelas de planos. Contate o suporte!'
      },
      insert: {
        title: 'Inserir Plano em Tabela de Planos - Legado',
        plan: 'Plano'
      }
    },
    planTable: {
      expandEntryList: 'Adicionar plano',
      create: {
        title: 'Criar Tabela de Planos - Legado',
        action: 'Criar Tabela de Planos',
        unknownError: 'Ocorreu um erro. Verifique se todos os campos estão preenchidos corretamente!'
      },
      manage: {
        title: 'Gerenciar Tabela de Planos - Versão 3',
        selectOption: 'Selecione uma opção',
        newPlanTable: '(CRIAR) Nova tabela de planos',
        planTable: 'Tabela de Planos',
        plans: ' Planos',
        productTable: 'Tabela de Produtos',
        newProductTable: 'Criar nova tabela de produtos',
        products: 'Produtos'
      },
      move: {
        title: 'Mover Usuário de Tabela de Planos',
        planTable: 'Tabela de Planos',
        caption: 'A opção carregada é a tabela atual deste usuário. Para alterá-la, clique na lista abaixo e selecione a tabela de planos desejada.',
        unknownError: 'Ocorreu um erro. Por favor contate o suporte!',
        action: 'Confirmar'
      }
    },
    filters: {
      create: {
        title: 'Adicionar Filtro',
        error: 'Erro ao adicionar filtro. Entre em contato com o suporte!',
        confirmButton: 'Adicionar',
        preset: {
          label: 'Pré-definição',
          tooltip: 'Crie um novo filtro a partir das pré-definições do filtro selecionado.',
          any: 'Nenhuma'
        },
        name: {
          label: 'Nome',
          errorText: 'Nome é obrigatório.'
        },
        description: {
          label: 'Descrição',
          tooltip: 'A descrição do filtro é gerada automaticamente através da seleção dos atributos no formulário.',
        },
        date: {
          doesntMatter: 'Não desejo saber',
          period: 'Período',
          lastDays: 'Últimos dias',
          daysAgo: 'Tempo de vida',
          before: 'Antes ou na data de',
          after: 'Na data ou depois de',
          errorText: 'Quantidade de dias é obrigatório.'
        },
        sign: {
          label: 'Operador',
          moreThan: 'Mais que',
          moreOrEqualTo: 'Mais ou igual a ',
          lessThan: 'Menos que',
          lessOrEqualTo: 'Menos ou igual a',
          equal: 'Igual a',
          between: 'Entre',
          quantity: 'Quantidade',
          minimumQuantity: 'Quantidade Mínima',
          maximumQuantity: 'Quantidade Máxima'
        },
        register: {
          label: 'Data de Cadastro',
          date: 'Data',
          begin: 'Início',
          end: 'Fim',
          days: 'Dias'
        },
        plan: {
          label: 'Sobre Planos',
          doesntMatter: 'Não desejo saber',
          activePlan: 'Com plano ativo',
          noActivePlan: 'Sem plano ativo',
          anyPlan: 'Qualquer plano',
          plan: 'Plano'
        },
        consults: {
          label: 'Sobre Consultas',
          doesntMatter: 'Não desejo saber',
          itMatters: 'Desejo saber',
          withConsults: 'Realizaram consultas',
          noConsults: 'Não realizaram consultas',
          errorText: 'Quantidade máxima é obrigatório.',
          errorText2: 'Quantidade máxima deve ser maior que a quantidade mínima.'
        },
        consultsTargets: {
          label: 'Sobre CPFs / CNPJs diferentes',
          tooltip: 'A quantidade informada será considerada para consultas de X CPFs OU X CNPJs diferentes.',
          errorText: 'Quantidade é obrigatório.',
          errorText2: 'Quantidade máxima é obrigatório.',
          errorText3: 'Quantidade máxima deve ser maior que a quantidade mínima.'
        },
        consultsDate: {
          label: 'Data das Consultas'
        },
        creditPurchase: {
          label: 'Sobre Compras de Crédito',
          doesntMatter: 'Não desejo saber',
          withCreditPurchase: 'Compraram créditos',
          noCreditPurchase: 'Não compraram créditos',
          value: 'Valor',
          minimumValue: 'Valor Mínimo',
          maximumValue: 'Valor Máximo',
          errorText: 'Valor máximo é obrigatório.',
          errorText2: 'Valor máximo deve ser maior que o valor mínimo.'
        },
        creditPurchaseDate: {
          label: 'Data das Compras de Crédito'
        },
        rdEvents: {
          title: 'Evento RD Station',
          label: 'Vincular Evento',
          tooltip: 'Vincule o filtro criado à um evento enviado de forma inteligente ao RD Station.',
          no: 'Não',
          yes: 'Sim',
          name: 'Nome do Evento'
        },
        rdEventsEnter: {
          label: 'Condição de Entrada',
          tooltip: 'Escolha quais usuários dispararão o evento.',
          newUsers: 'Novos usuários',
          allUsers: 'Todos os usuários',
          newUsersExplanation: '* O evento do RD Station será disparado somente por usuários que atenderem às condições do filtro após a sua ativação.',
          allUsersExplanation: '* O evento do RD Station será disparado por todos os usuários que já atendem às condições do filtro e também para novos usuários.'
        },
        rdEventsTriggerFrequency: {
          label: 'Frequência de Disparo',
          tooltip: 'Defina a frequência de disparo do evento.',
          everyDay: 'Todo dia',
          interval: 'Intervalo de dias',
          errorText: 'Intervalo de dias é obrigatório.'
        },
        rdEventsTriggerInitialDate: {
          label: 'Início do Disparo',
          tooltip: 'Defina a data para o primeiro disparo do evento.',
          tomorrow: 'Amanhã',
          anotherDay: 'Outro dia'
        }
      },
      manage: {
        title: 'Gerenciar Filtros',
        table: {
          columns: {
            id: 'Id',
            created_at: 'Criado em',
            name: 'Nome',
            description: 'Descrição',
            event: 'Evento RD Station'
          },
          options: {
            edit: 'Editar',
            close: 'Excluir'
          },
          type: {
            SYSTEM: 'Aviso do Sistema',
            INFO: 'Marketing'
          }
        }
      },
      edit: {
        title: 'Editar Filtro',
        error: 'Erro ao editar filtro. Entre em contato com o suporte!',
        returnButton: 'Voltar',
        confirmButton: 'Salvar'
      },
      remove: {
        title: 'Remover Filtro',
        text: 'Você tem certeza que deseja remover o filtro de id {{id}}?',
        error: 'Erro ao remover filtro. Entre em contato com o suporte!',
        notificationError: 'Atenção! Há notificações ativas que referenciam este filtro. Favor verificar as notificações com id: {{ids}}.',
        confirmButton: 'Sim, remover'
      },
    },
    products: {
      addToProductTables: 'Adicionar produto à tabelas de produtos existentes:',
      expandEntryList: 'Adicionar tabela',
      productTable: 'Tabela de Produtos',
      price: 'Preço',
      insertProduct: 'Inserir produto',
      errorRepeatedProductTables: 'Foram selecionadas duas ou mais tabelas de produtos iguais. Por favor verifique a lista.',
      unknownError: 'Erro desconhecido. Contate o suporte!',
      unknownFetchError: 'Ocorreu um erro ao carregar os dados. Contate o suporte!',
      unknownProductTableError: 'Ocorreu um erro ao carregar as tabelas de produtos. Contate o suporte!',
      insert: {
        title: 'Inserir Produto em Tabela de Produtos',
        product: 'Produto'
      }
    },
    productTable: {
      expandEntryList: 'Adicionar Produto',
      warning: 'Os produtos e preços listados inicialmente são os mesmos da tabela corrente (atual), com o intuito de fornecer uma base ao administrador que deseja criar uma tabela de produtos. Portanto, é possível modificá-los e/ou removê-los.',
      create: {
        title: 'Criar Tabela de Produtos',
        action: 'Criar Tabela de Produtos',
        unknownError: 'Ocorreu um erro. Verifique se todos os campos estão preenchidos corretamente!'
      },
      edit: {
        title: 'Alterar Tabela de Produtos',
        action: 'Salvar Tabela de Produtos'
      },
      move: {
        title: 'Mover Usuário de Tabela de Produtos',
        productTable: 'Tabela de Produtos',
        caption: 'A opção carregada é a tabela atual deste usuário. Para alterá-la, clique na lista abaixo e selecione a tabela de produtos desejada.',
        unknownError: 'Ocorreu um erro. Por favor contate o suporte!',
        action: 'Confirmar'
      }
    },
    notifications: {
      create: {
        title: 'Adicionar Notificação',
        error: 'Erro ao adicionar notificação. Entre em contato com o suporte!',
        validUntil: {
          label: 'Válida até',
          date: 'Data',
          today: 'Hoje',
          time: 'Hora',
          now: 'Agora',
        },
        type: {
          label: 'Tipo',
          system: 'Aviso do Sistema',
          info: 'Marketing',
          helperText: 'Selecione o tipo da notificação.',
          errorText: 'Tipo é obrigatório.'
        },
        message: {
          label: 'Mensagem',
          helperText: 'Digite a mensagem da notificação.',
          errorText: 'Mensagem é obrigatório.'
        },
        link: {
          label: 'Link',
          helperText: 'Caso deseje, digite o link de redirecionamento da notificação.',
        },
        filters: {
          label: 'Filtro de Usuários',
          helperText: 'Caso deseje, selecione o filtro de usuários para o envio da notifcação.',
          tooltip: 'Remover filtro'
        },
        confirmButton: 'Adicionar'
      },
      manage: {
        title: 'Gerenciar Notificações',
        table: {
          columns: {
            id: 'Id',
            created_at: 'Criada em',
            valid_until: 'Válida até',
            type: 'Tipo',
            message: 'Mensagem',
            link: 'Link',
            filter: 'Filtro'
          },
          options: {
            edit: 'Editar',
            close: 'Excluir'
          },
          type: {
            SYSTEM: 'Aviso do Sistema',
            INFO: 'Marketing'
          }
        }
      },
      edit: {
        title: 'Editar Notificação',
        error: 'Erro ao editar notificação. Entre em contato com o suporte!',
        returnButton: 'Voltar',
        confirmButton: 'Salvar'
      },
      remove: {
        title: 'Remover Notificação',
        text: 'Você tem certeza que deseja remover a notificação de id {{id}}?',
        error: 'Erro ao remover notificação. Entre em contato com o suporte!',
        confirmButton: 'Sim, remover'
      }
    }
  },

  cards: {
    recentConsults: {
      title: 'Consultas Recentes',
      caption: 'Confira suas consultas recentes sem custo algum, salvas na sua sessão atual.'
    },
    block: {
      title: 'Bloquear um usuário',
      caption: 'Digite o e-mail ou CNPJ correspondente a um usuário para pesquisá-lo.',
      textPlaceHolder: 'Pesquise por CPF / CNPJ',
      selectLabel: 'Tipo de Consulta',
      inputLabel: 'CPF / CNPJ',
      errors: {
        invalidField: 'E-mail ou CNPJ inválido',
        insertValue: 'Digite um e-mail ou CNPJ para começar!'
      },
    },
    customer: {
      btnRegister: 'Registrar novo usuário',
      btnBlock: 'Bloquear usuário'
    },
    financial: {
      title: 'Buscar usuário',
      caption: 'Digite o e-mail ou CNPJ correspondente a um usuário para gerar cobranças/assinaturas.',
      config: {
        btnUpdateIss: 'Atualizar alíquota ISS'
      }
    },
    plans: {
      title: 'Opções',
      btnCreatePlan: 'Criar plano',
      btnCreatePlanTableLegacy: 'Criar tabela de planos',
      btnInsertPlanToPlanTableLegacy: 'Inserir plano em tabela de planos',
      btnAddUserToPlanTable: 'Mover usuário de tabela de planos',
      legacy: 'Legado',
      btnManagePlanTable: 'Gerenciar Tabela de Planos',
      v3: 'Versão 3'
    },
    planSearch: {
      title: 'Buscar usuário',
      caption: 'Digite o e-mail ou CNPJ correspondente a um usuário para adicioná-lo a uma tabela de mensalidades de planos.'
    },
    products: {
      title: 'Opções',
      btnInsert: 'Inserir produto em tabela de produtos',
      btnCreateTable: 'Criar tabela de produtos',
      btnEditTable: 'Alterar tabela de produtos',
      btnAddUserToProductTable: 'Mover usuário de tabela de produtos'
    },
    productSearch: {
      title: 'Buscar usuário',
      caption: 'Digite o e-mail ou CNPJ correspondente a um usuário para adicioná-lo a uma tabela de preços de produtos.'
    },
    search: {
      btn: 'Buscar'
    },
    filters: {
      btnCreate: 'Adicionar filtro',
      btnFilter: 'Filtrar',
      filterName: 'Filtro Aplicado:',
      filterDescription: 'Descrição:',
      usersQuantity: 'Total de Usuários:'
    },
    notifications: {
      btnCreate: 'Adicionar notificação',
      btnEdit: 'Gerenciar notificações'
    },
    consultCpf: {
      title: 'Você irá consultar o seguinte CPF'
    },
    consultCnpj: {
      title: 'Você irá consultar o seguinte CNPJ'
    },
    documents: {
      title: 'Documentos',
      caption: 'Aqui estão localizados todos os documentos relacionados à sua conta.'
    },
    faq: {
      title: 'Perguntas frequentes'
    },
    support: {
      title: 'Fale conosco',
      caption: 'Dúvidas? Algo está funcionando indevidamente? Não hesite em nos contatar.'
    },
    product: {
      btnConsult: 'Consultar Agora',
      price: '{{price}} por consulta',
      moreDetails: 'Mais Detalhes'
    },
    planDetail: {
      currentPlan: {
        title: 'Plano atual',
        caption: 'Confira detalhes do seu plano atual.',
        validTo: 'Próxima cobrança em',
        endsAt: 'Acaba em',
        month: 'mês',
        noPlan: 'Você não possui um plano ativo. Confira os planos na tabela abaixo!',
        willEnd: {
          active: 'Sua assinatura será renovada {{date}}. Se a forma de pagamento foi cartão de crédito, será cobrada de forma automática.',
          canceled: 'Sua assinatura acabará {{date}}. Caso queira, você pode adquirir um novo plano.'
        }
      },
      cancelPlan: {
        button: 'Cancelar Assinatura'
      },
      errorPlan: 'Erro ao carregar seu plano. Contate o suporte!',
    },
    planManager: {
      title: 'Gerenciar plano',
      caption: 'Gerencie os detalhes do seu plano atual.'
    },
    walletBalance: {
      title: 'Saldo disponível',
      caption: 'Verifique o saldo de crédito atualmente disponível em sua conta. O saldo possui validade e pode ser usado apenas para consultas.',
      errors: {
        loading: 'Erro ao carregar seu saldo! Entre em contato com o suporte.'
      },
      balanceWarning: 'Confira com detalhes a validade de cada recarga na tabela de Saldo Detalhado logo abaixo.'
    },
    walletBuy: {
      title: 'Comprar créditos para avulsas',
      caption: 'Adquira créditos para utilizar em suas consultas. Cada crédito adquirido, tem validade de 60 dias a partir da confirmação do pagamento.',
      amountField: 'Quantia',
      btnBuy: 'Comprar',
      errors: {
        purchase: 'Erro ao efetuar sua compra',
        unknown: 'Erro desconhecido! Contate nosso suporte.',
        minAmount: 'O valor mínimo de recarga é de R$ 1,99'
      },
      success: {
        text: 'Pronto! Agora é necessário realizar o pagamento. Caso você não for redirecionado automaticamente, clique no botão abaixo para ser ir à página de pagamento, no site do Asaas.com, com conexão segura.',
        btnPay: 'Ir ao Pagamento'
      },
      advisor: 'Precisa fazer muitas consultas e quer um desconto? Confira nossos planos',
      clickingHere: 'clicando aqui'
    },
    productList: {
      title: 'Tabela de preços',
      caption: 'Confira o preço unitário de cada tipo de consulta.'
    }
  },

  forms: {
    login: {
      login: 'E-mail',
      password: 'Senha',
      btn: 'Acessar 4KST Consulta',
    },
    checkout: {
      step_one: {
        cnpj: 'CNPJ da sua empresa',
        zipcode: 'CEP do endereço de cobrança',
        street: 'Logradouro',
        district: 'Bairro',
        city: 'Cidade',
        state: 'Estado (UF)',
        street_number: 'Numeral',
        details: 'Complemento',
        password: 'Senha desejada',
        confirmPassword: 'Repetir senha'
      },
      step_two: {
        cpf: 'CPF',
        name: 'Nome completo',
        email: 'E-mail',
        phone_1: 'Telefone principal',
        password: 'Senha',
        confirmPassword: 'Repita sua senha',
        cnpj: 'Seu CNPJ'
      }
    },
    customerRegister: {
      cpf: 'CPF',
      name: 'Nome completo',
      email: 'E-mail',
      phone1: 'Telefone principal',
      btn: 'Registrar usuário',
      company: 'CNPJ Empresa',
      includePlanTable: 'Incluir tabela de planos',
      planTable: 'Tabela de planos',
      includeProductTable: 'Incluir tabela de produtos',
      productTable: 'Tabela de produtos',
      includeMarketplace: 'Incluir marketplace',
      marketplace: 'Marketplace',
      includeSponsoredCredit: 'Incluir créditos patrocinados',
      sponsoredCredit: 'Valor',
      shouldSubscribe: 'Incluir plano',
      subscriptionPlan: 'Plano',
      default: 'Padrão',
      tips: {
        sponsoredCredit: 'Adiciona um determinado valor de créditos para o usuário criado, por conta da 4KST.',
        planTable: 'Ao ser criado, o usuário será inserido em uma tabela de planos. Caso essa opção não estiver marcada, o usuário será inserido na tabela de planos padrão.',
        plan: 'Ativa um plano para o usuário criado, por conta da 4KST.',
        productTable: 'Ao ser criado, o usuário será inserido em uma tabela de produtos. Caso essa opção não estiver marcada, o usuário será inserido na tabela de produtos padrão.',
        marketplace: 'Marque essa opção para criar um usuário de marketplace. Escolha o marketplace desejado.'
      }
    },
    customerAddress: {
      title: 'Endereço de Cobrança',
      street: 'Rua',
      street_number: 'Número',
      district: 'Bairro',
      city: 'Cidade',
      state: 'Estado (UF)',
      zipcode: 'CEP',
      details: 'Complemento',
      errorFeedback: 'Ocorreu um erro ao salvar seus dados! Tente novamente ou entre em contato com o suporte.',
      successFeedback: 'Dados salvos com sucesso.'
    },
    customer: {
      title: 'Dados Cadastrais',
      cpf: 'CPF',
      email: 'E-mail',
      name: 'Nome completo',
      phone_1: 'Telefone principal',
      errorFeedback: 'Ocorreu um erro ao salvar seus dados! Tente novamente ou entre em contato com o suporte.',
      successFeedback: 'Dados salvos com sucesso.'
    },
    financial: {
      amount: 'Valor',
      paymentMethod: 'Método de pagamento',
      plan: 'Plano',
      valueTooLow: 'O valor informado é muito baixo!',
      Error: 'Ocorreu um erro desconhecido. Contate o suporte técnico!',
      chargeURL: 'Sua cobrança foi criada! Clique na caixa abaixo para copiar o link de pagamento, visualizar as informações e enviá-lo ao cliente.',
      unknownFetchError: 'Ocorreu um erro ao carregar os planos disponíveis para esse cliente.',
      subscription: {
        enableMaxPayments: 'Habilitar número máximo de mensalidades',
        maxPayments: 'Número máximo de mensalidades',
        invalidMaxPayments: 'Número máximo de mensalidades inválido!',
        nextStepPlanTable: 'Próximo: escolher plano',
        nextStepPlan: 'Criar tabela de planos',
        skipPlanTableStep: 'Pular etapa',
        stepBack: 'Voltar',
        paymentInfo: 'Dados de pagamento',
        planTableInfo: 'Tabela de planos',
        planInfo: 'Plano',
        unknownFetchError: 'Ocorreu um erro ao carregar os planos disponíveis para esse cliente.'
      }
    },
    planTable: {
      tableName: 'Nome',
      tableDescription: 'Descrição',
      plans: 'Planos',
      validUntil: 'Válida até',
      validUntilTooltip: 'Todas as tabelas de planos têm data de expiração. Uma vez que uma tabela expira, o usuário volta à tabela de planos padrão.',
      version: 'Versão'
    },
    productTable: {
      productTable: 'Tabela de Produtos',
      tableName: 'Nome',
      tableDescription: 'Descrição',
      products: 'Produtos',
      validUntil: 'Válida até',
      validUntilTooltip: 'Todas as tabelas de produto têm data de expiração. Uma vez que uma tabela expira, o usuário volta à tabela padrão.',
      version: 'Versão'
    }
  },

  screens: {
    loginScreen: {
      title: 'Tela Login',
      errors: {
        '400': 'Informações inválidas.',
        common: 'Erro ao efetuar login.',
        unverifiedEmail: 'Seu e-mail não foi confirmado! Solicite uma confirmação '
      },
      registerSuccess: 'Registrado com sucesso! Entre com suas informações abaixo para realizar o acesso.',
      recoverSuccess: 'Senha alterada com sucesso! Entre abaixo com suas informações.',
      verificationSuccess: 'E-mail confirmado com sucesso! Entre abaixo com suas informações.',
      requestVerificationSuccess: 'Passos para confirmação enviados! Verifique seu e-mail para continuar com a ativação de sua conta.',
      btnCreateAccount: 'Criar conta',
      forgotPassword: 'Esqueceu sua senha?',
      clickingHereBtn: 'clicando aqui.'
    },
    registerScreen: {
      alreadyHasAcc: 'Você já tem uma conta?',
      login: 'Fazer login',
      companyNotFound: 'Não encontrou sua empresa? Envie um e-mail para suporte@4kst.com',
      errors: {
        '400': 'Informações inválidas.',
        common: 'Erro ao cadastrar! Contate o suporte.'
      },
    },
    checkoutScreen: {
      main: {
        invalidPlan: 'Plano inválido para compra.',
        planSummary: 'Resumo da sua compra'
      },
      step_one: {
        errors: {
          NOT_FOUND: 'O CNPJ informado não existe.',
          NOT_ACTIVE: 'O CNPJ informado não está ativo perante a Receita Federal!',
          INVALID_ACTIVITIES: 'Os CNAEs do CNPJ informado não permitem a utilização do 4KST Consulta. Para mais esclarecimentos, contate nosso suporte via e-mail em consulta@4kst.com.',
          UNKNOWN: 'Um erro desconhecido ocorreu! Contate nosso suporte em consulta@4kst.com ou tente novamente mais tarde.'
        },
        title: 'Olá! Seja bem-vindo(a) ao 4KST Consulta!',
        subtitle: 'Para começar seu cadastro, por favor nos informe seu CNPJ.'
      },
      step_two: {
        title: 'Certo! Agora é só preencher seus dados pessoais abaixo.'
      },
      step_three: {
        plan: {
          title: 'Revise sua compra'
        },

        credit: {
          title: 'Informe a quantia de créditos que você deseja recarregar em sua conta.',
          errors: {
            minValue: 'O valor mínimo de recarga é de R$ 1,99'
          },
          label: 'Quantia desejada'
        }
      }
    }
  },

  panels: {
    block: {
      table: {
        title: "Usuário(s) encontrado(s)",
        columns: {
          id: "Identificador",
          full_name: "Nome completo",
          email: "E-mail",
          phone: "Telefone",
          last_login: "Último login",
          cnpj: "CNPJ",
          is_blocked: "Bloqueio"
        }
      }
    },
    customer: {
      title: 'Usuário'
    },
    financial: {
      title: 'Financeiro - Cobranças',
      table: {
        action: 'Gerar cobrança',
        columns: {
          action: 'Ação'
        }
      },
      config: {
        title: 'Financeiro - Configurações'
      }
    },
    plans: {
      title: 'Planos'
    },
    planSearch: {
      table: {
        action: 'Alterar tabela de plano'
      }
    },
    product: {
      title: 'Produtos'
    },
    products: {
      title: 'Produtos'
    },
    productSearch: {
      table: {
        action: 'Alterar tabela de produtos'
      }
    },
    search: {
      result: "Resultado da busca: ",
      email: {
        none: "Nenhum e-mail foi encontrado para a busca atual.",
        unknown: "Ocorreu um erro desconhecido ao efetuar sua busca. Por favor contate o suporte."
      },
      cnpj: {
        none: "Nenhum CNPJ foi encontrado para a busca atual.",
        unknown: "Ocorreu um erro desconhecido ao efetuar sua busca. Por favor contate o suporte."
      }
    },
    filters: {
      title: 'Filtros',
      list: {
        title: 'Listagem',
        table: {
          title: 'Usuários Filtrados',
          columns: {
            id: 'Id',
            company: 'Razão Social',
            name: 'Nome',
            email: 'E-mail',
            phone: 'Telefone',
            credits: 'Total de Créditos',
            consults: 'Total de Consultas',
            cpfs: 'CPFs',
            cnpjs: 'CNPJs',
            plan: 'Plano',
            registerDate: 'Data de Cadastro'
          }
        }
      }
    },
    notifications: {
      title: 'Notificações'
    },
    managerLog: {
      title: 'Histórico de Ações',
      selectField: {
        label: 'Pesquisar por',
        MANAGER: 'Gerente',
        ACTION_CLASS: 'Categoria de Ações',
        ACTION: 'Ação',
        MONTH: 'Mês'
      },
      selectManagerField: {
        label: 'Digite o e-mail do gerente'
      },
      selectActionClassField: {
        Product: 'Produto',
        ProductTable: 'Tabela de Produtos',
        ProductPrice: 'Preço de Produto',
        Plan: 'Plano',
        PlanProduct: 'Desconto de Plano',
        PlanTable: 'Tabela de Planos',
        PlanPrice: 'Mensalidade de Plano',
        Subscription: 'Assinatura',
        Filter: 'Filtro',
        Notification: 'Notificação',
        Config: 'Configuração',
        Customer: 'Cliente',
        Payment: 'Cobrança',
        Sale: 'Promoção'
      },
      selectActionField: {
        //Product
        CreateProduct: 'Criação de Produto',
        UpdateProduct: 'Alteração de Produto',
        DeleteProduct: 'Exclusão de Produto',

        //ProductTable
        CreateProductTable: 'Criação de Tabela de Produtos',
        UpdateProductTable: 'Alteração de Tabela de Produtos',
        DeleteProductTable: 'Exclusão de Tabela de Produtos',

        //ProductPrice
        CreateProductPrice: 'Atribuição de Preço a Produto',
        UpdateProductPrice: 'Alteração de Preço de Produto',
        DeleteProductPrice: 'Exclusão de Preço de Produto',

        //Plan
        CreatePlan: 'Criação de Plano',
        UpdatePlan: 'Alteração de Plano',
        DeletePlan: 'Exclusão de Plano',

        //PlanProduct
        CreatePlanProduct: 'Atribuição de Desconto a Plano',
        UpdatePlanProduct: 'Alteração de Desconto de Plano',
        DeletePlanProduct: 'Exclusão de Desconto de Plano',

        //PlanTable
        CreatePlanTable: 'Criação de Tabela de Planos',
        UpdatePlanTable: 'Alteração de Tabela de Planos',
        DeletePlanTable: 'Exclusão de Tabela de Planos',

        //PlanPrice
        CreatePlanPrice: 'Atribuição de Mensalidade a Plano',
        UpdatePlanPrice: 'Alteração de Mensalidade de Plano',
        DeletePlanPrice: 'Exclusão de Mensalidade de Plano',

        //Subscription
        SubscribeCustomer: 'Ativação de Assinatura Promocional para Cliente',

        //Filter
        CreateFilter: 'Criação de Filtro',
        UpdateFilter: 'Alteração de Filtro',
        DeleteFilter: 'Exclusão de Filtro',

        //Notification
        CreateNotification: 'Criação de Notificação',
        UpdateNotification: 'Alteração de Notificação',
        DeleteNotification: 'Exclusão de Notificação',

        //Config
        CreateConfigEntry: 'Criação de Configuração',
        UpdateConfigEntry: 'Alteração de Configuração',
        DeleteConfigEntry: 'Exclusão de Configuração',

        //Customer
        BlockCustomer: 'Bloqueio de Cliente',
        UnblockCustomer: 'Desbloqueio de Cliente',
        CreateCustomer: 'Cadastro de Cliente',
        CreateSponsoredCustomer: 'Cadastro de Cliente Patrocinado',
        UpdateCustomer: 'Alteração de Cadastro de Cliente',
        DeleteCustomer: 'Exclusão de Cadastro de Cliente',

        //Payment
        CreatePayment: 'Geração de Cobrança: Avulsa',
        CreateSubscription: 'Geração de Cobrança: Assinatura',

        //Sale
        CreateSale: 'Criação de Promoção',
        UpdateSale: 'Alteração de Promoção',
        DeleteSale: 'Exclusão de Promoção'
      },
      table: {
        columns: {
          manager_email: 'Gerente',
          timestamp: 'Data e Hora',
          action_class: 'Categoria',
          action: 'Ação',
          month: 'Mês',
          status: 'Nível de Criticidade'
        },
        data: {
          status: {
            INFO: 'Baixo',
            WARN: 'Médio',
            ERROR: 'Alto'
          },
          other: {
            invoice_iss: 'Alíquota ISS'
          }
        },
        details: {
          title: 'Detalhes: ',
          blocked: 'Bloqueado: ',
          bureauId: 'Cód. Bureau: ',
          cnpj: 'CNPJ: ',
          cpf: 'CPF: ',
          createdAt: 'Criada Em: ',
          currentTable: 'Tabela Atual: ',
          customerId: 'Cód. Cliente: ',
          description: 'Descrição: ',
          discount: 'Desconto: ',
          email: 'E-mail: ',
          filterId: 'Cód. Filtro: ',
          manager: 'Gerente: ',
          message: 'Mensagem: ',
          marketplaceId: 'Cód. Marketplace: ',
          maximumNumberOfMonthlyFees: 'Nº máximo de mensalidades: ',
          name: 'Nome: ',
          no: ' Não',
          notificationId: 'Cód. Notificação: ',
          paymentGatewayId: 'Cód. Gateway de Pagamento: ',
          paymentMethod: 'Método de Pagamento: ',
          phone: 'Telefone: ',
          planId: 'Cód. Plano: ',
          planTableId: 'Cód. Tabela de Planos: ',
          productId: 'Cód. Produto: ',
          productTableId: 'Cód. Tabela de Produtos: ',
          saleId: 'Cód. Promoção: ',
          special: 'Especial: ',
          type: 'Tipo: ',
          url: 'Link: ',
          validUntil: 'Válido Até: ',
          validUntil2: 'Válida Até: ',
          value: 'Valor: ',
          verified: 'Verificado: ',
          yes: 'Sim',
        }
      }
    },
    cpf: {
      title: 'Consulta CPF',
      info: 'Analise e conceda crédito para Pessoa Física com segurança e agilidade.',
      errors: {
        alreadyConsulted: 'Este CPF já foi consultado.',
        alreadyConsultedComplete: 'Uma consulta completa deste CPF já foi realizada.',
        unknown: 'Erro ao efetuar a consulta! Confira os detalhes.'
      },
      noConsults: 'Não há consultas recentes por aqui! Clique aqui para fazer consultas.'
    },
    cnpj: {
      title: 'Consulta CNPJ',
      info: 'Analise e conceda crédito para Pessoa Jurídica com segurança e agilidade.',
      errors: {
        alreadyConsulted: 'Este CNPJ já foi consultado.',
        alreadyConsultedComplete: 'Uma consulta completa deste CNPJ já foi realizada.',
        unknown: 'Erro ao efetuar a consulta! Confira os detalhes.'
      },
      noConsults: 'Não há consultas recentes por aqui! Clique aqui para fazer consultas.'
    },
    plan: {
      title: 'Planos',
      activePlanInfo: 'Confira todos os detalhes do plano contratado. Para mudança de plano, consulte as demais opções.',
      noActivePlanInfo: 'Conheça os Planos 4KST Consulta. Quanto maior o plano contratado, maiores são os descontos.',
      table: {
        currentPlan: 'Plano Atual',
        subscribe: 'Assinar Plano',
        single: 'Avulsa',
        consultType: 'Tipo de Consulta',
        minimumCharge: 'carga mínima de R$ 1,99',
        buyCredits: 'Comprar Créditos'
      },
      contact: 'Precisa de outros planos que não estão especificados na tabela? Entre em contato com nosso time de vendas através do e-mail consulta@4kst.com'
    },
    myAccount: {
      title: 'Meus dados',
      info: 'Nesta seção você encontra as informações da sua conta.'
    },
    support: {
      title: 'Suporte',
      info: 'Tire suas dúvidas ou contate nosso suporte aqui.'
    },
    consultTypes: {
      title: 'Tipos de consulta',
      info: 'Nesta seção você encontra os tipos de consulta disponíveis no 4KST Consulta.'
    },
    billing: {
      title: 'Faturamento',
      info: 'Confira nesta seção todas as cobranças realizadas em sua conta.',
      cancelOrder: {
        success: 'Cobrança cancelada com sucesso.'
      },
      table: {
        title: 'Faturamento detalhado',
        caption: 'Verifique o extrato das suas últimas cobranças em sua conta.',
        columns: {
          id: 'N° da Cobrança',
          amount: 'Valor',
          issue_date: 'Data de Emissão',
          due_date: 'Data de Vencimento',
          status: 'Situação',
          type: 'Tipo'
        },
        data: {
          status: {
            PENDING: 'Aguardando Pagamento',
            RECEIVED: 'Pgto. Confirmado',
            CONFIRMED: 'Pgto. Confirmado',
            RECEIVED_IN_CASH: 'Pgto. Confirmado',
            OVERDUE: 'Venceu',
            REFUNDED: 'Estornada',
            REFUND_REQUESTED: 'Estorno Solicitado',
            CHARGEBACK_REQUESTED: 'Contestação Solicitada',
            CHARGEBACK_DISPUTE: 'Em Disputa de Contestação',
            AWAITING_CHARGEBACK_REVERSAL: 'Aguardando Contestação',
            DUNNING_REQUESTED: 'Recuperação Solicitada',
            DUNNING_RECEIVED: 'Recuperada',
            AWAITING_RISK_ANALYSIS: 'Em Análise',
            DELETED: 'Cancelada'
          },
          type: {
            PLAN: 'Assinatura do {{planName}}',
            WALLET: 'Compra de Crédito'
          }
        },
        actions: {
          cancel: 'Cancelar',
          viewPayment: 'Ver Pagamento',
          invoice: 'Ver Nota Fiscal'
        },
        detail: {
          type: {
            BOLETO: 'Boleto Bancário',
            CREDIT_CARD: 'Cartão de Crédito',
            DEBIT_CARD: 'Cartão de Débito',
            TRANSFER: 'Transferência Bancária',
            DEPOSIT: 'Depósito Bancário',
            PIX: 'PIX'
          },
          method: 'Forma de Pagamento',
          paymentDate: 'Data de Confirmação'
        }
      }
    },
    wallet: {
      title: 'Crédito para avulsas',
      info: 'Nesta seção você poderá ver, administrar e recarregar o saldo da sua conta apenas para consultas avulsas. Se deseja adquirir planos, ',
      table: {
        title: 'Saldo detalhado',
        caption: 'Verifique seu extrato de forma detalhada. Consulte cada recarga e sua validade.',
        columns: {
          amount: 'Valor',
          valid_until: 'Válido Até',
          expired: 'Expirado',
          type: 'Tipo',
          createdAt: 'Data da Compra'
        },
        data: {
          expired: {
            true: 'Sim',
            false: 'Não'
          },
          type: {
            PLAN: 'Crédito do {{planName}}',
            WALLET: 'Compra de Crédito'
          }
        }
      }
    },
    report: {
      title: 'Relatório de Uso',
      info: 'Nesta seção você poderá obter um relatório para acompanhar suas consultas na plataforma.',
      table: {
        title: 'Relatório detalhado',
        caption: 'Verifique o relatório das suas consultas dos últimos 30 dias.',
        columns: {
          target: 'CPF / CNPJ consultado',
          type: 'Tipo de Consulta',
          createdAt: 'Data da Consulta',
          unit_price: 'Valor Pago'
        }
      }
    }
  },

  drawer: {
    customer: 'Usuário',
    financial: 'Financeiro',
    billing: 'Cobranças',
    financialConfig: 'Configurações',
    plans: 'Planos',
    filters: 'Filtros',
    filtersManage: 'Gerenciar',
    filtersList: 'Listar',
    products: 'Produtos',
    notifications: 'Notificações',
    managerLog: 'Histórico de Ações',
    exit: 'Sair'
  },

  materialTableLocale: {
    body: {
      emptyDataSourceMessage: 'Nenhum registro para exibir!',
      deleteTooltip: 'Deletar',
      editTooltip: 'Editar',
      editRow: {
        deleteText: 'Tem certeza que deseja deletar este dado?',
        cancelTooltip: 'Cancelar',
        saveTooltip: 'Salvar'
      }
    },
    toolbar: {
      searchTooltip: 'Pesquisar',
      exportTitle: 'Exportar',
      exportCSVName: "Exportar como CSV",
      exportPDFName: "Exportar como PDF"
    },
    pagination: {
      labelRowsSelect: 'linhas',
      labelDisplayedRows: '{count} de {from}-{to}',
      firstTooltip: 'Primeira página',
      previousTooltip: 'Página anterior',
      nextTooltip: 'Próxima página',
      lastTooltip: 'Última página'
    },
    header: {
      actions: 'Opções'
    },
    grouping: {
      placeholder: 'Arraste o título das colunas para agrupá-las',
      groupedBy: 'Agrupado por'
    }
  },

  loren: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
}

export default PT